import type { CategoryBanner } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import { type FC } from 'react'
import type { Settings } from 'react-slick'
import ImageOptimize from '../ImageOptimize'
import Slider from '../Slider/Slider'

interface Props {
  data: CategoryBanner[]
  className?: string
}

export const BannerProductListing: FC<Props> = ({ data, className }: Props) => {
  const settings: Settings = {
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
  }

  const sliderCategoryData = data
    ?.filter(e => e.type === 'slider')
    .sort((a, b) => a.order - b.order)

  return sliderCategoryData?.length ? (
    <Slider {...settings} className={`rounded-lg px-1 ${className}`}>
      {sliderCategoryData.map((e, i) => (
        <Link
          className='!block w-full overflow-hidden rounded-lg'
          href={e.path || ''}
          key={i}
        >
          <ImageOptimize
            src={e.image || ''}
            width={1312}
            height={210}
            alt={getTranslate(e.name)}
            priority
            className='h-[210px] w-full bg-full'
          />
        </Link>
      ))}
    </Slider>
  ) : null
}
